import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadsReports } from '../../../components/leads-reports/leads-reports';

@Component({
  selector: 'app-reports-leads',
  standalone: true,
  imports: [
    CommonModule,
    LeadsReports
  ],
  templateUrl: './leads.html',
  styleUrls: ['./leads.scss']
})
export class ReportsLeads {
}

